import axios from "axios";

// Ana URL (geliştirme ve prod için dinamik yapabilirsin)
const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL, // 👈 backend endpoint
  headers: {
    "Content-Type": "application/json",
  },
  //withCredentials: false, // gerekirse cookie bazlı auth için true yapılır
});
 

// REQUEST interceptor — TOKEN EKLEME
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token"); // AuthContext yerine storage’dan alıyoruz

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    const activeBranchId = localStorage.getItem("activeBranchId");
    if (activeBranchId) {
      config.headers["X-Branch-Id"] = activeBranchId;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
 
// 🚨 Response Interceptor
api.interceptors.response.use(
  (response) => response,
  (error) => {
    // İptal edilen (AbortController / CancelToken) istekleri hata olarak loglama
    if (axios.isCancel(error) || error?.code === "ERR_CANCELED" || error?.name === "CanceledError") {
      return Promise.reject(error);
    }

    // Genel hata yakalama
    if (error.response) {
      console.error("API Hatası:", error.response);

      // Yetki hatası
      if (error.response.status === 401) {
        localStorage.removeItem("token");
        window.location.href = "/login";
        console.warn("Oturum süresi doldu!");
      }
    } else {
      console.error("Sunucuya ulaşılamadı:", error);
    }

    return Promise.reject(error);
  }
);

export default api;
